import { render } from "./index.vue?vue&type=template&id=2565b8f4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2565b8f4&scoped=true&lang=css"

import exportComponent from "F:\\2024-岗亭\\jxwx-carpark-duty\\jxwx-carpark-duty\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2565b8f4"]])

export default __exports__